module.exports = __webpack_public_path__ + "static/media/Untitled-6.e000d55e.png";